// extracted by mini-css-extract-plugin
export var container = "Upper-module--container--ADdJO";
export var inner = "Upper-module--inner--3iCcU";
export var links = "Upper-module--links--16ZE0";
export var dot = "Upper-module--dot--1sh1t";
export var socialContainer = "Upper-module--social-container--2WCyb";
export var logo = "Upper-module--logo--3AZlT";